import { useState, useEffect } from 'react';
import { authService } from '../services/auth.service';

export const useSessionExpired = () => {
  const [isSessionExpiredModalOpen, setIsSessionExpiredModalOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = authService.onSessionExpired(() => {
      setIsSessionExpiredModalOpen(true);
    });

    return () => unsubscribe();
  }, []);

  const handleCloseSessionExpiredModal = () => {
    setIsSessionExpiredModalOpen(false);
  };

  return {
    isSessionExpiredModalOpen,
    handleCloseSessionExpiredModal
  };
};
